import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { sum, round } from 'lodash';

import DifferenceComponent from './DifferenceComponent';
import { grandTotal } from '../../../utils/chart/ChartManagementFeatures/showChartFeatures';
import { getPercentDifference } from '../../../utils/period/PercentComponent';

// находит разницу между столбцом дополнительного периода и основного.
const getDifferencePeriod = (series, key, basePoint) => {
  const allChartSeries = series.chart.series;
  const currentUniqueChar = series.userOptions.parentId;
  const isAdditionalPeriod = !!currentUniqueChar.split('').filter((c) => Number(c)).length;

  if (isAdditionalPeriod) {
    return undefined;
  }

  const filterSeries = ({ userOptions }) =>
    isAdditionalPeriod
      ? userOptions.parentId.length === 1 && currentUniqueChar[0] === userOptions.parentId
      : userOptions.parentId.length > 1 && currentUniqueChar === userOptions.parentId[0];

  // находим серии с дополнительными периодами
  const seriesWithUniqueChar = allChartSeries.filter(filterSeries);

  const arrayResalts = seriesWithUniqueChar
    .flatMap(({ data }) => data)
    .filter(({ name }) => name === key);

  // массив данных с различиями от основного периода
  const diffsArr = arrayResalts.map((item) => {
    const diff = basePoint - item.y;
    const percentDiff =
      diff < 0
        ? getPercentDifference(item.y, basePoint) * -1
        : getPercentDifference(item.y, basePoint);

    const uniqueChar = item.series.name.split('.')[0];
    const isShown = item.series.visible;

    return {
      isShown,
      uniqueChar,
      differenceValue: diff,
      differencePercent: percentDiff,
    };
  });

  return <DifferenceComponent diffsArr={diffsArr} />;
};

const getRoundedPercentString = (percentage) => `${Math.round(percentage * 100) / 100}%`;

const calcPercent = (num, total) => (num * 100) / total;

const TooltipGrandTotal = (isAdditionalPeriods, isSplit, { series, key, y, percentage, total }) => {
  const grandTotalVal = series.data.find((s) => String(s.name) === grandTotal).total;
  const sumSelectedSeries = sum(series.processedYData.slice(0, -1));

  return ReactDOMServer.renderToStaticMarkup(
    isSplit ? (
      <div>
        <div className="tooltip-bold">{key}</div>
        <div>{series.name}</div>
        <div>
          Value: <span className="tooltip-bold">{round(y, 2)}</span>
        </div>
        <div>
          is: <span className="tooltip-bold">{getRoundedPercentString(percentage)}</span> of
        </div>
        <div>
          {key} of: <span className="tooltip-bold">{round(total, 2)}</span>
        </div>
        <div>
          and:{' '}
          <span className="tooltip-bold">
            {getRoundedPercentString(calcPercent(y, sumSelectedSeries))}
          </span>{' '}
          of
        </div>
        <div>
          Total of {series.name} of:{' '}
          <span className="tooltip-bold">{round(sumSelectedSeries, 2)}</span>
        </div>
        <div>
          and:{' '}
          <span className="tooltip-bold">
            {getRoundedPercentString(calcPercent(y, grandTotalVal))}
          </span>{' '}
          of
        </div>
        <div>
          {grandTotal} of: <span className="tooltip-bold">{round(grandTotalVal, 2)}</span>
        </div>
        {isAdditionalPeriods && getDifferencePeriod(series, key, total)}
      </div>
    ) : (
      <div>
        <div className="tooltip-bold">{key}</div>
        <div>{series.name}</div>
        <div>
          Value: <span className="tooltip-bold">{round(y, 2)}</span>
        </div>
        <div>
          is:{' '}
          <span className="tooltip-bold">
            {getRoundedPercentString(calcPercent(y, grandTotalVal))}
          </span>{' '}
          of
        </div>
        <div>
          {grandTotal} of: <span className="tooltip-bold">{round(grandTotalVal, 2)}</span>
        </div>
        {isAdditionalPeriods && getDifferencePeriod(series, key, total)}
      </div>
    )
  );
};

const Tooltip = (isAdditionalPeriods, isSplit, chart) => {
  const { series, key, y, percentage, total } = chart;

  return ReactDOMServer.renderToStaticMarkup(
    isSplit ? (
      <div>
        <div className="tooltip-bold">{key}</div>
        <div>{series.name}</div>
        <div>
          Value: <span className="tooltip-bold">{round(y, 2)}</span>
        </div>
        <div>
          is: <span className="tooltip-bold">{getRoundedPercentString(percentage)}</span> of
        </div>
        <div>
          {key} of: <span className="tooltip-bold">{round(total, 2)}</span>
        </div>
        {isAdditionalPeriods && getDifferencePeriod(series, key, total)}
      </div>
    ) : (
      <div>
        <div className="tooltip-bold">{key}</div>
        <div>{series.name}</div>
        <div>
          Value: <span className="tooltip-bold">{round(y, 2)}</span>
        </div>
        {isAdditionalPeriods && getDifferencePeriod(series, key, total)}
      </div>
    )
  );
};

const PeriodColumnTooltip = (isAdditionalPeriods, isSplit, isGrandTotal, chart) =>
  isGrandTotal
    ? TooltipGrandTotal(isAdditionalPeriods, isSplit, chart)
    : Tooltip(isAdditionalPeriods, isSplit, chart);

export default PeriodColumnTooltip;
